import { NextSeo } from 'next-seo';

//screens
import { DetentionHandling } from '@/screens/Agents/DetentionHandling';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function DetentionHandlingPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/detention-handling/"
        title="Detention Handling Agent | Loadsmart AI"
        description="Uses Opendock appointment and gate timestamps to warn the dock lead before a truck runs past its free time, and reports dwell and detention by carrier and facility. For shippers who pay detention, it also checks a carrier’s request against those timestamps and your contract rates."
        openGraph={{
          url: 'https://loadsmart.com/ai/detention-handling/',
          images: [
            {
              url: `${process.env.SITE_URL}/images/share/ai/detention-handling.png`,
              width: 1200,
              height: 630,
              alt: 'Detention Handling Agent',
              type: 'image/png',
            },
          ],
        }}
      />
      <JsonLd data={Organization} />
      <DetentionHandling />
    </>
  );
}
